<div class="orphan-municipality">
  <mat-accordion class="orphan-accordion">
    <mat-expansion-panel class="expansion-panel">
      <mat-expansion-panel-header collapsedHeight="auto" expandedHeight="auto">
        <span class="fa fa-warning"></span>
        <div class="warning-message">
          <p class="warning">{{ 'module.userProfile.regionalAdmin.unassignedMunicipalitiesLabel' | translate }}</p>
          <p class="subtitle">{{ 'module.userProfile.regionalAdmin.unassignedMunicipalitiesSubLabel' | translate }}</p>
        </div>
      </mat-expansion-panel-header>
      <div class="unassigned-municipalities-list">
        <div class="header">
          <div class="name">{{ 'module.userProfile.regionalAdmin.municipalityNameText' | translate }}</div>
          <div class="edit">{{ 'module.userProfile.regionalAdmin.assignRegionsText' | translate }}</div>
        </div>
        <div class="municipality-list">
          <div class="municipality" *ngFor="let municipality of municipalities; trackBy: trackByFn">
            <div class="name">{{ municipality.municipalityName }}</div>
            <div class="edit icon"><span class="fa fa-pencil" (click)="edit(municipality)"></span></div>
          </div>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>
